export default __webpack_public_path__ + "static/media/logo_4.8227d2ca.svg";